module.exports = __webpack_public_path__ + "img/celerops.5a1f7dea.png";